export default {
  entityName: "Exchange Rate",
  apiEndpoint: "/master/exchange-rates",
  permissions: {
    view: "master:view",
    edit: "master:edit",
  },
  columns: [
    { key: "fromCurrency", label: "From Currency", sortable: true, class: () => "font-mono font-bold" },
    { key: "toCurrency", label: "To Currency", sortable: true, class: () => "font-mono font-bold" },
    { key: "rate", label: "Conversion Rate", sortable: true },
    { key: "effectiveDate", label: "Effective Date", sortable: true, formatter: (val) => val ? new Date(val).toLocaleDateString() : '—' },
    { key: "source", label: "Source", sortable: true },
  ],
  fields: [
    { name: "fromCurrency", label: "From Currency (ISO)", type: "text", required: true, uppercase: true, placeholder: "e.g. USD" },
    { name: "toCurrency", label: "To Currency (ISO)", type: "text", required: true, uppercase: true, placeholder: "e.g. INR" },
    { name: "rate", label: "Exchange Rate", type: "number", required: true, placeholder: "e.g. 83.50", min: 0 },
    { name: "effectiveDate", label: "Effective Date", type: "date", required: true },
    { name: "source", label: "Rate Source", type: "select", options: ["manual", "exchange-rate-api", "auto-calculated"], default: "manual" },
  ],
  filters: [],
  workflow: {
    enabled: false,
  },
};
